export const silver = (value: number | null | undefined) => value == null || !Number.isFinite(value)
  ? 'Keine Daten'
  : new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(value);

export const percent = (value: number | null | undefined) => value == null || !Number.isFinite(value) ? '—' : `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value)} %`;

export function ageLabel(timestamp: string | null, now = Date.now()) {
  if (!timestamp) return 'Keine Daten';
  const minutes = Math.max(0, (now - new Date(timestamp).getTime()) / 60_000);
  if (minutes < 60) return `${Math.round(minutes)} Min.`;
  if (minutes < 1_440) return `${(minutes / 60).toFixed(1)} Std.`;
  return `${(minutes / 1_440).toFixed(1)} Tage`;
}

export function downloadCsv(filename: string, rows: object[]) {
  if (!rows.length) return;
  const records = rows as Array<Record<string, unknown>>;
  const headers = Object.keys(records[0]!);
  const escape = (value: unknown) => `"${String(value ?? '').replaceAll('"', '""')}"`;
  const csv = [headers.map(escape).join(','), ...records.map((row) => headers.map((header) => escape(row[header])).join(','))].join('\n');
  const link = document.createElement('a');
  link.href = URL.createObjectURL(new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' }));
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
